import React from 'react';

interface PaneContentWrapperProps {
  children: React.ReactNode;
  paneId: string;
}

export const PaneContentWrapper = ({ children }: PaneContentWrapperProps) => {
  return <>{children}</>;
};
